import { render } from "./AddGroup.vue?vue&type=template&id=75a6ad80&ts=true"
import script from "./AddGroup.vue?vue&type=script&lang=ts"
export * from "./AddGroup.vue?vue&type=script&lang=ts"

import exportComponent from "/home/vsts/work/1/s/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__